declare var require: any;

/** Версия из package.json. Одна на оба портала, поэтому живёт в общем модуле. */
export const GUI_VERSION: string = require('../../../../../package.json').version;
